




import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  name: 'GVTag',
})
export default class GVTag extends Vue {
  @Prop({ default: 'Have some error' })
  public message: string;
  @Prop({ default: 'error' })
  public type: string;
}
